import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private token: string;

  constructor() { 
    this.token = this.getToken();
    console.log("gettoken is", this.token);
  }

  public getSession() {
    if(!this.token) return null;
    const splits = this.token.split('.');

    const part1 = atob(splits[0]);
    const part2 = atob(splits[1]);
    const user = JSON.parse(part2);
    if(user.exp <= this.currentTimeInSeconds()) {
      this.setToken('');
      return null;
    }
    return user;
  }

  private currentTimeInSeconds() {
    return Math.floor(Date.now()/1000);
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  public setToken(token: string) {
    this.token = token;
    localStorage.setItem('token', token);
  }
}
